import { ActionContext } from "vuex";

const state = {
  isLoading: false,
  loaded: false,
  loadingCount: 0
};

const getters = {
  isLoading: (state: any) => state.isLoading,
  loaded: (state: any) => state.loaded
};

const actions = {
  loading(context: ActionContext<any, any>) {
    context.commit("LOADING");
  },
  doneLoading(context: ActionContext<any, any>) {
    context.commit("DONE_LOADING");
  }
};

const mutations = {
  LOADING(state: any) {
    state.loaded = false;
    state.isLoading = true;
    state.loadingCount = state.loadingCount + 1;
  },
  DONE_LOADING(state: any) {
    state.loadingCount = state.loadingCount - 1;
    if (state.loadingCount < 0) {
      state.loadingCount = 0;
    }
    if (state.loadingCount == 0) {
      state.loaded = true;
      state.isLoading = false;
    }
  }
};

const Global = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default Global;
